import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MetaGuard } from '@ngx-meta/core';

import { FrontendPanelLayoutComponent } from './shared/frontend-layout/FrontendPanel.component';
import { PrivateLayoutComponent } from './shared/private-layout/private-layout.component';
import { AuthenticationGuard } from './core/auth/services/authentication.guard';




const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	},
	{
		path: '',
		canActivateChild: [MetaGuard],
		children:
			[
				{
					path: '',
					loadChildren: () => import('./landingpage/dashboard.module').then(m => m.DashboardModule)
				}
			]
	},
	{
		path: 'account',
		canActivateChild: [MetaGuard],
		loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
	},
	{
		path: 'admin',
		component: PrivateLayoutComponent,
		canActivateChild: [MetaGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
			}
		]
	},
	{
		path: 'articles',
		canActivateChild: [MetaGuard],
		loadChildren: () => import('./articles/articles.module').then(m => m.ArticlesModule)
	},
	{
		path: 'blog',
		canActivateChild: [MetaGuard],
		loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule)
	},
	{
		path: 'gallery',
		canActivateChild: [MetaGuard],
		loadChildren: () => import('./gallery/gallery.module').then(m => m.GalleryModule)
	},
	{
		path: 'map',
		canActivateChild: [MetaGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('./map/map.module').then(m => m.MapModule)
			}
		]
	},
	{
		path: 'trip-planner',
		canActivateChild: [MetaGuard],
		loadChildren: () => import('./trip-planner/trip-planner.module').then(m => m.TripPlannerModule)
	},
	{
		path: 'comments',
		component: PrivateLayoutComponent,
		children: [
			{
				path: '',
				loadChildren: () => import('./comment/comment.module').then(m => m.CommentModule)
			}
		]
	},
	{
		path: 'chat',
		canActivateChild: [MetaGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule)
			}
		]
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		initialNavigation: 'enabled',
		scrollPositionRestoration: 'enabled'
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }
